import { createInstance, type i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE, type SupportedLocale } from "./locales";

type CreateCultureI18nResult = {
  i18n: i18n;
  initialization: Promise<unknown>;
};

export function createCultureI18n(locale: SupportedLocale = DEFAULT_LOCALE): CreateCultureI18nResult {
  const i18nInstance = createInstance();
  const initialization = i18nInstance.use(initReactI18next).init({
    resources: {},
    lng: locale,
    fallbackLng: locale,
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

  return {
    i18n: i18nInstance,
    initialization,
  };
}
